import { useQuery } from "@tanstack/react-query";

import { getTodayPacingMetrics } from "../../../../api/getTodayPacingMetrics";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const useTodayPacingMetrics = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: ["today-pacing-metrics"],
        queryFn: async () => getTodayPacingMetrics(apiClients.gamification),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
